module.exports = __webpack_public_path__ + "static/media/banner.993f864b.jpeg";